export const department = (rowData) => rowData.department.name